/**
 * White-label branding for the auth screens (consume-only; the upload UI is a
 * separate ticket). Returns defaults today.
 * TODO(DEV-3110): source `logoUrl`/`heroImageUrl` from the platform config store.
 */

/** Default bundled wordmark (served from /public/auth). */
export const DEFAULT_AUTH_LOGO = '/auth/logo-investbanq.svg';

export interface AuthBranding {
  /** Logo shown above the form. Falls back to the bundled Investbanq wordmark. */
  logoUrl: string;
  /** Custom hero image. When set, it replaces the facts widget on the hero panel. */
  heroImageUrl: string | null;
  /** True when a tenant has uploaded a custom hero image (facts widget hidden). */
  isWhiteLabel: boolean;
}

export function useAuthBranding(): AuthBranding {
  // No platform-customization config wired yet — source it here when it lands.
  const config: { logoUrl?: string; heroImageUrl?: string } = {};

  const heroImageUrl = config.heroImageUrl ?? null;

  return {
    logoUrl: config.logoUrl ?? DEFAULT_AUTH_LOGO,
    heroImageUrl,
    isWhiteLabel: heroImageUrl !== null,
  };
}
